import Dexie from 'dexie';

export class AppDatabase extends Dexie {
  constructor() {
    super('WaifuBriscolaDB');
    this.version(1).stores({ translations: 'locale', syncMetadata: 'key' });
  }
}

export const db = new AppDatabase();

